import { gql } from "@apollo/client";

export const removeStylesheetsQuery = gql`
mutation removeStylesheetsQuery($ids: [String!]!) {
  removeStylesheets(ids: $ids) {
    success
  }
}
`;
